/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckQuestionSampleImage } from './PaxCheckQuestionSampleImage';
import {
    PaxCheckQuestionSampleImageFromJSON,
    PaxCheckQuestionSampleImageFromJSONTyped,
    PaxCheckQuestionSampleImageToJSON,
    PaxCheckQuestionSampleImageToJSONTyped,
} from './PaxCheckQuestionSampleImage';
import type { PaxCheckQuestionTitle } from './PaxCheckQuestionTitle';
import {
    PaxCheckQuestionTitleFromJSON,
    PaxCheckQuestionTitleFromJSONTyped,
    PaxCheckQuestionTitleToJSON,
    PaxCheckQuestionTitleToJSONTyped,
} from './PaxCheckQuestionTitle';

/**
 * A Yes/No question (boolean), manifested through a positive statement of 'I do have {document type}' format
 * @export
 * @interface PaxCheckHaveDocumentQuestion
 */
export interface PaxCheckHaveDocumentQuestion {
    /**
     * Question id
     * @type {string}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    id: string;
    /**
     * Whether question is relevant for this passenger, according to current answers to all questions
     * @type {boolean}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    isRelevant: boolean;
    /**
     * Question answer, if was provided
     * @type {boolean}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    answer?: boolean | null;
    /**
     * 
     * @type {PaxCheckQuestionTitle}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    questionTitle: PaxCheckQuestionTitle;
    /**
     * 
     * @type {PaxCheckQuestionSampleImage}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    sampleImage?: PaxCheckQuestionSampleImage;
    /**
     * Document category sort order
     * @type {number}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    docCategoryOrder: number;
    /**
     * Document category (localised)
     * @type {string}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    docCategoryTitle: string;
    /**
     * Document title (localised)
     * @type {string}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    docTitle: string;
    /**
     * Document country code (iso alpha-3) - can be EURO
     * @type {string}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckHaveDocumentQuestion
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckHaveDocumentQuestion interface.
 */
export function instanceOfPaxCheckHaveDocumentQuestion(value: object): value is PaxCheckHaveDocumentQuestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isRelevant' in value) || value['isRelevant'] === undefined) return false;
    if (!('questionTitle' in value) || value['questionTitle'] === undefined) return false;
    if (!('docCategoryOrder' in value) || value['docCategoryOrder'] === undefined) return false;
    if (!('docCategoryTitle' in value) || value['docCategoryTitle'] === undefined) return false;
    if (!('docTitle' in value) || value['docTitle'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckHaveDocumentQuestionFromJSON(json: any): PaxCheckHaveDocumentQuestion {
    return PaxCheckHaveDocumentQuestionFromJSONTyped(json, false);
}

export function PaxCheckHaveDocumentQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckHaveDocumentQuestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isRelevant': json['is_relevant'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'questionTitle': PaxCheckQuestionTitleFromJSON(json['question_title']),
        'sampleImage': json['sample_image'] == null ? undefined : PaxCheckQuestionSampleImageFromJSON(json['sample_image']),
        'docCategoryOrder': json['doc_category_order'],
        'docCategoryTitle': json['doc_category_title'],
        'docTitle': json['doc_title'],
        'country': json['country'] == null ? undefined : json['country'],
        'type': json['type'],
    };
}

export function PaxCheckHaveDocumentQuestionToJSON(json: any): PaxCheckHaveDocumentQuestion {
    return PaxCheckHaveDocumentQuestionToJSONTyped(json, false);
}

export function PaxCheckHaveDocumentQuestionToJSONTyped(value?: PaxCheckHaveDocumentQuestion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'is_relevant': value['isRelevant'],
        'answer': value['answer'],
        'question_title': PaxCheckQuestionTitleToJSON(value['questionTitle']),
        'sample_image': PaxCheckQuestionSampleImageToJSON(value['sampleImage']),
        'doc_category_order': value['docCategoryOrder'],
        'doc_category_title': value['docCategoryTitle'],
        'doc_title': value['docTitle'],
        'country': value['country'],
        'type': value['type'],
    };
}

